import ConfirmPasswordRule from './confirm-password.rule.js';
import PasswordMinLengthRule from './password-min-length.rule.js';
import EmailIsAvailableRule from './email-is-available.rule';
import HtmlNativeFeedbackRule from './html-native-feedback.rule';
import AtLeastNCharsRule from './password/at-least-n-chars.rule';
import ExpectUppercaseRule from './password/expect-uppercase.rule';
import ExpectLowercaseRule from './password/expect-lowercase.rule';
import ExpectSpecialCharRule from './password/expect-special-char.rule';
import ExpectNumberRule from './password/expect-number.rule';
import NotBlankRule from './not-blank.rule';

export default {
    'confirm-password': ConfirmPasswordRule,
    'password-min-length': PasswordMinLengthRule,
    'email-is-available': EmailIsAvailableRule,
    'html-native-feedback': HtmlNativeFeedbackRule,
    'at-least-n-chars': AtLeastNCharsRule,
    'expect-uppercase': ExpectUppercaseRule,
    'expect-lowercase': ExpectLowercaseRule,
    'expect-special-char': ExpectSpecialCharRule,
    'expect-number': ExpectNumberRule,
    'not-blank': NotBlankRule
}
